import { Box, useComputedColorScheme } from "@mantine/core";

import meshSvg from "./assets/mesh.svg";
import { getShellPageBackgroundColor } from "./shell-page-background";

export type MeshBackgroundProps = {
  isCustomizationPanelOpen: boolean;
  /** e.g. `"400px"` — used to keep the gradient centred when the panel shifts content */
  customizationPanelWidthCss: string;
};

export const MeshBackground = ({
  isCustomizationPanelOpen,
  customizationPanelWidthCss,
}: MeshBackgroundProps) => {
  const colorScheme = useComputedColorScheme("light");
  const bgColor = getShellPageBackgroundColor();
  const bgColorVar =
    "light-dark(var(--mantine-color-gray-dark-3), var(--mantine-color-gray-dark-10))";
  const panelWidthNum = Number.parseInt(customizationPanelWidthCss, 10);
  const translateX = isCustomizationPanelOpen ? `${panelWidthNum / 2}px` : "0";

  return (
    <>
      <Box
        style={{
          position: "fixed",
          inset: 0,
          width: "100dvw",
          height: "100dvh",
          backgroundColor: bgColor,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <Box
        data-testid="mesh-background-overlay"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100dvw",
          height: "100dvh",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100dvw",
            height: "100dvh",
            background: `radial-gradient(ellipse at 50% 50%, ${bgColor} 0%, color-mix(in srgb, ${bgColorVar} 80%, transparent) 40%, transparent 70%)`,
            transform: `translateX(${translateX})`,
            transition: "transform 0.2s ease-in-out",
            pointerEvents: "none",
          }}
        />
      </Box>

      <Box
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100dvw",
          height: "100dvh",
          backgroundImage: `url(${meshSvg})`,
          backgroundSize: "1000px",
          backgroundPosition: "center",
          backgroundRepeat: "repeat",
          opacity: colorScheme === "dark" ? 0.05 : 0.05,
          filter: colorScheme === "dark" ? undefined : "invert(1)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
    </>
  );
};
